import { useEffect } from 'react'
import { useNavigate } from 'router-v6'
import { SuspenseLoader } from 'v2/shared/components/suspense-loader'
import { settingsService } from 'v2/shared/services/settings-service'
import { errorToast } from 'v2/utils/toasts'

// PylonLogin handles the Pylon Customer Portal SSO redirect.
// Pylon redirects an unauthenticated customer here with a `redirect_uri` query
// param. This route is protected, so the user is already authenticated by the
// time it renders (otherwise the route guard bounces them through /login and
// back, preserving the query). We forward the query to hodor, which mints a
// signed JWT and returns the final URL (redirect_uri + access_token), then send
// the browser there to complete the Pylon login.
export const PylonLogin = () => {
  const navigate = useNavigate()

  useEffect(() => {
    let cancelled = false
    const doRedirect = async () => {
      try {
        const query = window.location.search.replace(/^\?/, '')
        const { data } = await settingsService.getPylonLogin(query)
        if (!cancelled && data?.url) {
          window.location.href = data.url
          return
        }
        throw new Error('No redirect URL received')
      } catch (err) {
        if (!cancelled)
          errorToast({
            title:
              err instanceof Error
                ? err.message
                : 'Something went wrong while redirecting to the customer portal',
          })
        if (!cancelled) navigate('/home')
      }
    }
    doRedirect()
    return () => {
      cancelled = true
    }
  }, [navigate])

  return <SuspenseLoader text="Redirecting to the customer portal..." />
}
